import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationArchiveVariationsArgs, BackendVariations } from 'src/types/backend';

import { VARIATION_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ArchiveVariations($ids: [ID!]!) {
    archiveVariations(ids: $ids) {
      variations {
        ...Variation
      }
    }
  }
  ${VARIATION_FRAGMENT}
`;

type Variables = BackendMutationArchiveVariationsArgs;
type Result = Pick<BackendVariations, 'variations'>;

export const archiveVariations = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
